'use client';
import { formatName } from '@leland-dev/leland-ui-library';
import { useSearchParams } from 'next/navigation';
import { type FC } from 'react';

import { type SkuTier } from '../../__generated-gql-types__/globalTypes';
import { SUBSCRIBER_DUMMY_COACH_URN } from '../../utils/constants';
import OfferingPackagePage from '../package/OfferingPackagePage';
import NotFoundPage from '../page/NotFoundPage';

import {
  type ApplicantPlanPageOfferingPackageFragment,
  useApplicantPlanPageOfferingPackageBySlugQuery,
} from './__generated-gql-types__/[packageSlug].generated';

interface ApplicantPlanPageProps {
  offeringPackage: Possible<ApplicantPlanPageOfferingPackageFragment>;
}

const ApplicantPlanPage: FC<ApplicantPlanPageProps> = ({ offeringPackage }) => {
  const searchParams = useSearchParams();

  const tierToUse = searchParams.get('coachTier') as Optional<SkuTier>;

  const { data: clientData } = useApplicantPlanPageOfferingPackageBySlugQuery({
    variables: {
      coach: SUBSCRIBER_DUMMY_COACH_URN,
      slug: offeringPackage?.slug ?? '',
      categorySlugOrUrn: offeringPackage?.category?.id ?? '',
      visibleTierOnly: !tierToUse,
      tier: tierToUse,
    },
    skip: !offeringPackage?.category || !tierToUse,
  });

  const offeringPackageToUse =
    clientData?.offeringPackageBySlug ?? offeringPackage;

  if (!offeringPackageToUse) {
    return <NotFoundPage entity="package" />;
  }

  const titleFragments = [
    `${offeringPackageToUse.name} by ${formatName(
      offeringPackageToUse.coach.user,
    )}`,
  ];
  if (offeringPackageToUse.category) {
    titleFragments.push(`${offeringPackageToUse.category.name} Package`);
  }

  return (
    <OfferingPackagePage
      offeringPackage={offeringPackageToUse}
      coachPackages={null}
    />
  );
};

export default ApplicantPlanPage;
